import { useTranslation } from 'react-i18next';

import { Alert } from 'components/Display/Alert/Alert';

export const ConnectionErrorFallback = () => {
  const { t } = useTranslation();
  return (
    <div className="p-3">
      <Alert severity="error" title={t('webedi:sidebar.agents.connectionError.title')}>
        <p>{t('webedi:sidebar.agents.connectionError.description')}</p>
      </Alert>
    </div>
  );
};
